import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import { exportToImg } from '../../helpers/Export';

class Export extends React.PureComponent {
  export = () => {
    const { exportAction } = this.props;

    if (exportAction) {
      exportAction();
    } else {
      const { exportId, exportName, exportConfigs, theme } = this.props;
      exportToImg(exportId, exportName, theme, exportConfigs);
    }
  };

  render() {
    const { title, onClickExportCustom } = this.props;

    return (
      <a
        href="#"
        className="btn btn-cus-nomal bg-b-color-3"
        onClick={() => {
          if (onClickExportCustom) return onClickExportCustom();
          this.export();
        }}
      >
        <div>
          <i className="icon-printer-tool fs-12 mr-5" />
          <span className="font-weight-bold">
            <Translate value={title} />
          </span>
        </div>
      </a>
    );
  }
}

Export.propTypes = {
  title: PropTypes.string.isRequired,
  exportId: PropTypes.string,
  exportName: PropTypes.string,
  exportConfigs: PropTypes.object,
  exportAction: PropTypes.func,
};

Export.defaultProps = {
  title: 'common.EXPORT',
  onClickExportCustom: null,
};

const mapStateToProps = state => ({
  theme: state.theme,
});

export default connect(mapStateToProps)(Export);
